<script setup lang="ts">
import { type DirectSaleListingItemEntity, DirectSaleState } from '~/apiClient';

// PROPS
interface Props {
    directSale: DirectSaleListingItemEntity;
}

const { directSale } = defineProps<Props>();

// COMPOSABLES
const { isSold } = useDirectSaleStatus(toRef(() => directSale));
const { tt } = useTypedI18n();

// DATA
const showBadge = computed(() => directSale.state === DirectSaleState.Open && !isSold.value);
</script>

<template>
    <span v-if="showBadge" class="flex items-center gap-0.5 rounded-full border border-solid border-neutral-400 bg-white px-2 py-1 text-sm">
        <UIcon class="text-muted" name="lucide:info" />
        <span class="text-highlighted">{{ tt('slp.DirectSale.negotiationAvailableBadge.title') }}</span>
    </span>
</template>
